import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

function getSystemPrefersDark() {
  try { return window.matchMedia("(prefers-color-scheme: dark)").matches; } catch { return false; }
}

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => {
    try {
      const stored = localStorage.getItem("theme_mode");
      if (stored === "light" || stored === "dark" || stored === "auto") return stored;
      const legacy = localStorage.getItem("theme");
      if (legacy === "dark") return "dark";
    } catch {}
    return "light";
  });
  const [systemDark, setSystemDark] = useState(getSystemPrefersDark);

  useEffect(() => {
    let mq;
    try { mq = window.matchMedia("(prefers-color-scheme: dark)"); } catch { return; }
    const handler = (e) => setSystemDark(e.matches);
    if (mq.addEventListener) mq.addEventListener("change", handler);
    else if (mq.addListener) mq.addListener(handler);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", handler);
      else if (mq.removeListener) mq.removeListener(handler);
    };
  }, []);

  const dark = mode === "auto" ? systemDark : mode === "dark";

  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
  }, [dark]);

  useEffect(() => {
    try { localStorage.setItem("theme_mode", mode); } catch {}
  }, [mode]);

  return (
    <ThemeContext.Provider value={{ dark, mode, setMode }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
